/**
 * Copyright 2024 Dell Inc. or its subsidiaries. All Rights Reserved.
 */

import { ApolloClient, gql } from "@apollo/client/core";
import { PendoData } from "./pendo-user-data.model";
import { TdmApolloClient } from "../client/tdm-apollo-client";

export class PendoUserDataService {
  private readonly apolloClient: ApolloClient<any>;

  // GraphQL query for fetching Pendo data
  public static readonly PENDO_DATA_QUERY = gql`
    query PendoData {
      currentUser {
        email
        roles {
          name
        }
      }
      currentCompany {
        id
        name
        services(filter: { status: "ACTIVE", visible: true }) {
          service {
            serviceCode
          }
        }
      }
    }
  `;

  public constructor(tdmApolloClient: TdmApolloClient) {
    // Initializing ApolloClient instance
    this.apolloClient = tdmApolloClient.getClient();
  }

  // Method for querying user data for initializing Pendo
  public async queryUserData(): Promise<PendoData> {
    return this.apolloClient
      .query<PendoData>({
        query: PendoUserDataService.PENDO_DATA_QUERY,
        errorPolicy: "all",
      })
      .then((response) => response?.data);
  }
}
